import React from "react";
import { getCaseDetailsSpecialActions } from "../../../../services/Product/ProductService/productService";
import { Box } from "@mui/material";

import { ProductUnion } from "../../../../types/ProductUnion";

type CaseDetailsSpecialActionsProps = {
  product: ProductUnion;
};
const CaseDetailsSpecialActions = ({ product }: CaseDetailsSpecialActionsProps) => {
  const caseDetailsSpecialActions = getCaseDetailsSpecialActions(product);
  if (caseDetailsSpecialActions) {
    return <Box sx={{ marginTop: "1rem" }}>{caseDetailsSpecialActions}</Box>;
  }
  return null;
};
export default CaseDetailsSpecialActions;
